"use strict";
/*
 * Created on 28. 1. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts attributes of {@link ExportedPriceListRow exported price list row}.
 * @author Radek Beran
 */


var ExportedPriceListRowConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ExportedPriceListRowConverter, _DataObjectConverter_);

  function ExportedPriceListRowConverter() {
    _classCallCheck(this, ExportedPriceListRowConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ExportedPriceListRowConverter).apply(this, arguments));
  }

  return ExportedPriceListRowConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ExportedPriceListRowConverter = ExportedPriceListRowConverter;